import Footer from "../../components/Footer";
import Header from "../../components/Header";
import "./Story.css";
import story8 from "../../assets/me3.png";
import story9 from "../../assets/me2.jpeg";

function Story() {
  return (
    <div className="story">
      <Header />
      <div className="story_body">
        <section className="story_section_one">
          <div>
            <h3>My Story</h3>
            <h1>Engineering, Computation, and Curiosity</h1>
          </div>
        </section>

        <section className="story_section_two">
          <img src={story8} className="story_section_two_image" />
          <div>
            <div>
              <h1>It's not enough to exist, One must live.</h1>
              <p>
                I have long been guided by the belief that existence alone is
                not sufficient and one must pursue purpose, growth, and
                meaningful contribution. This perspective shapes both my
                academic journey and personal development. Alongside my work in
                engineering and technology, I value creativity and thoughtful
                reflection, whether through music, strategic thinking in chess,
                or simply enjoying the outdoors.
              </p>
            </div>
          </div>
        </section>
        <section className="story_section_two">
          <img src={story9} className="story_section_two_image" />
          <div>
            <div>
              <h1>Early Motivation.</h1>
              <p>
                My interest in engineering began early, driven by a curiosity
                about how physical systems work and how they can be designed and
                improved. As a teenager, I explored mechanical concepts
                independently, studying from textbooks and applying ideas
                through small design projects.
              </p>
            </div>
          </div>
        </section>
        <section className="story_section_three">
          <h3>THIS IS ME IN A NUTSHELL</h3>
          <h1>
            I'm a christian, a researcher, technology enthusiast and a soccer
            fan.
          </h1>
        </section>

        <section className="story_section_five">
          <h1>Back Story</h1>
          <div>
            <p>
              My interest in engineering began early, driven by a natural
              curiosity about how systems are designed and built. By the age of
              13, this curiosity had evolved into a clear sense of direction,
              sparked by an ambitious attempt to conceptualize and fabricate a
              bicycle from first principles. What began as a simple idea quickly
              revealed the depth of knowledge required, leading me to
              independently study foundational concepts in mechanical
              engineering using borrowed textbooks. This experience marked the
              beginning of a sustained engagement with design, analysis, and
              creative problem-solving.
            </p>

            <p>
              During my undergraduate studies in mechanical engineering at the
              University of Benin, I developed a strong foundation in
              thermodynamics, fluid mechanics, and system design. My early
              exposure to industrial practice, particularly during my internship
              at NNPC–Chevron, provided valuable insight into large-scale
              engineering systems and contributed significantly to my
              understanding of control systems and process integration.
            </p>

            <p>
              Over time, my interests evolved toward the computational
              dimensions of engineering. I became increasingly interested in how
              numerical methods and simulation techniques can be used to model,
              predict, and optimize physical systems. This transition led me
              into software development and scientific computing, where I began
              building tools and models to address complex engineering problems,
              guided by a central question: how can technology be leveraged to
              solve meaningful problems and improve systems efficiency?
            </p>
          </div>
        </section>
        <section className="story_section_five">
          <h1>Current Direction.</h1>
          <div>
            <p>
              I am currently pursuing a Master’s degree in Nuclear Engineering
              at IMT Atlantique, where my work focuses on computational
              modeling, radiation transport, and thermo-fluid systems. My
              research is centered on the application of numerical methods to
              analyze particle interactions, energy systems, and transport
              phenomena across multiple scales, with an emphasis on developing
              accurate and efficient representations of complex physical
              processes.
            </p>

            <p>
              Beyond formal research, I maintain a strong interest in writing,
              analytical thinking, and continuous learning. My journey into
              building a personal and professional identity reflects a broader
              commitment to not only developing technical expertise but also
              contributing knowledge and insight to others. I am particularly
              interested in helping individuals and organizations build
              meaningful systems, both in software and in personal development.
            </p>

            <p>
              On a personal note, my outlook and discipline have been profoundly
              influenced by my mother, whose example continues to shape my
              approach to growth, resilience, and purpose.
            </p>
          </div>
        </section>

        <section className="story_section_three">
          <h3>MY STORY CONTINUES, BUT OFF THE WEB</h3>
          <h1>
            Now that you know part of my story, you have seen a glimpse of my
            soul. I exist outside the web and I would love to share my story
            with you personally.
          </h1>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default Story;
